import React from 'react'
import styled from 'styled-components'
import { reportTea } from 'UTILS'
import ActiveButton from '../active-button'
import { ReactComponent as Yes } from 'ASSETS/svg/icon_yes.svg'
import { ReactComponent as Line } from 'ASSETS/svg/icon_line.svg'
import { ReactComponent as Intro1 } from 'ASSETS/svg/intro1.svg'
import { ReactComponent as Intro2 } from 'ASSETS/svg/intro2.svg'
import { ReactComponent as IconExpand } from 'ASSETS/svg/icon-expand.svg'
import { Collapse } from '@arco-design/web-react'

const intros = [
  {
    header: '支持的图片格式',
    content: [
      {
        title: '常规图像文件格式（包括 PNG、JPEG、WebP、GIF）',
        lite: true,
        imagex: true,
      },
      {
        title: '高压缩图像文件格式（包括 HEIF、AVIF）',
        lite: true,
        imagex: true,
      },
    ],
  },
  {
    header: '支持的基础处理能力',
    content: [
      {
        title: '图片压缩/格式转化',
        lite: true,
        imagex: true,
      },
      {
        title: '图片旋转/翻转',
        lite: true,
        imagex: true,
      },
      {
        title: '图片缩放',
        lite: true,
        imagex: true,
      },
      {
        title: '图片裁剪',
        lite: true,
        imagex: true,
      },
      {
        title: '添加图文水印',
        lite: true,
        imagex: true,
      },
      {
        title: '锐化',
        lite: true,
        imagex: true,
      },
      {
        title: '负片',
        lite: true,
        imagex: true,
      },
      {
        title: '亮度调节',
        lite: true,
        imagex: true,
      },
      {
        title: '高斯模糊',
        lite: true,
        imagex: true,
      },
      {
        title: '对比度调节',
        lite: true,
        imagex: true,
      },
      {
        title: '饱和度调节',
        lite: true,
        imagex: true,
      },
    ],
  },
  {
    header: '支持的高阶处理能力',
    content: [
      {
        title: '漫画风格迁移',
        lite: false,
        imagex: true,
      },
      {
        title: '智能识别裁剪',
        lite: true,
        imagex: true,
      },
      {
        title: '智能抠图（支持人像/商品抠图）',
        lite: true,
        imagex: true,
      },
      {
        title: '智能识别填充',
        lite: false,
        imagex: true,
      },
      {
        title: '图像内容擦除',
        lite: false,
        imagex: true,
      },
      {
        title: '画质增强',
        lite: true,
        imagex: true,
      },
      {
        title: '图像超分辨率',
        lite: true,
        imagex: true,
      },
      {
        title: '盲水印',
        lite: true,
        imagex: true,
      },
      {
        title: '画质评分',
        lite: true,
        imagex: true,
      },
    ],
  },
  {
    header: '使用限制',
    content: [
      {
        title: '上传图片总数',
        lite: ' ≤100 张/日',
        imagex: '无限制',
      },
      {
        title: '并发处理图片数量',
        lite: ' ≤10 张',
        imagex: '无限制',
      },
      {
        title: '图片操作有效期',
        lite: ' ≤1 小时',
        imagex: '无限制',
      },
      {
        title: '图片处理模版导出/保存',
        lite: false,
        imagex: true,
      },
    ],
  },
]

const Intro = () => {
  return (
    <div
      style={{
        width: '100%',
        background:
          'linear-gradient(0deg, rgba(245, 248, 255, 0.7) 0%, rgba(248, 251, 255, 0.2) 100%)',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <Container>
        <Title>服务介绍</Title>
        <Content>您可以根据需要，选择更适合您的产品方案</Content>
        <IntroContaienr>
          <IntroTitle>veImageX（体验版）</IntroTitle>
          <IntroContent>
            满足小批量图片的基础处理和格式转化需求，轻量快捷的编辑图片内容
          </IntroContent>
          <IntroItem text="常规图像文件格式"></IntroItem>
          <IntroItem text="高压缩 HEIF 与 AVIF 文件格式"></IntroItem>
          <IntroItem text="11 类基础图片处理能力"></IntroItem>
          <IntroItem text="6 类高阶图片处理能力"></IntroItem>
          <IntroItem text="有限的使用权限"></IntroItem>
          <ActiveButton
            style={{
              marginTop: '48px',
            }}
            onClick={() => {
              reportTea('click_experience')
              window.open('/')
            }}
          >
            立即体验
          </ActiveButton>
          <IconIntro1></IconIntro1>
        </IntroContaienr>
        <IntroContaienr style={{ marginTop: '12px' }}>
          <IntroTitle>veImageX（企业版）</IntroTitle>
          <IntroContent>
            提供便捷的一站式图片上传、存储、处理、分发服务，覆盖大批量图片全链路处理需求
          </IntroContent>
          <IntroItem text="veImageX 体验版的所有功能"></IntroItem>
          <IntroItem text="高压缩 HEIF 与 AVIF 文件格式"></IntroItem>
          <IntroItem text="11 类基础图片处理能力"></IntroItem>
          <IntroItem text="9 类高阶图片处理能力"></IntroItem>
          <IntroItem text="无限的使用权限"></IntroItem>
          <ActiveButton
            style={{
              marginTop: '48px',
            }}
            onClick={() => {
              reportTea('click_advance', {
                url_path: '/about',
                type: 'try',
              })
              window.open(
                'https://www.volcengine.cn/products/imagex?utm_content=ImageX&utm_source=10zb5a&utm_term=ImageX-tryout',
              )
            }}
          >
            立即试用
          </ActiveButton>
          <IconIntro2></IconIntro2>
        </IntroContaienr>
        <CollapseTitle>
          <div style={{ width: '160px', padding: '0 8px 0 16px' }}>服务说明</div>
          <div style={{ flex: '1', display: 'flex', justifyContent: 'center' }}>
            体验版
          </div>
          <div style={{ flex: '1', display: 'flex', justifyContent: 'center' }}>
            企业版
          </div>
        </CollapseTitle>
        <StyledCollapse
          defaultActiveKey={['0', '1', '2', '3']}
          bordered={false}
          expandIcon={<IconExpand></IconExpand>}
        >
          {intros.map((intro, index) => {
            return (
              <Collapse.Item key={intro.header} name={`${index}`} header={intro.header}>
                {intro.content.map((item) => {
                  return (
                    <StyledRow key={item.title}>
                      <StyleCol style={{ width: '160px', padding: '0 8px 0 16px' }}>
                        <div style={{ width: '160px' }}>{item.title}</div>
                      </StyleCol>
                      <StyleCol style={{ flex: '1' }}>
                        {item.lite === true && (
                          <IconYes
                            style={{ width: '20px', height: '20px', margin: '0' }}
                          />
                        )}
                        {item.lite === false && <IconLine />}
                        {typeof item.imagex === 'string' && <div>{item.lite}</div>}
                      </StyleCol>
                      <StyleCol style={{ flex: '1' }}>
                        {item.imagex === true && (
                          <IconYes
                            style={{ width: '20px', height: '20px', margin: '0' }}
                          />
                        )}
                        {item.imagex === false && <IconLine />}
                        {typeof item.imagex === 'string' && <div>{item.imagex}</div>}
                      </StyleCol>
                    </StyledRow>
                  )
                })}
              </Collapse.Item>
            )
          })}
        </StyledCollapse>
      </Container>
    </div>
  )
}

const Container = styled.div`
  width: 343px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  padding-bottom: 64px;
`

const Title = styled.div`
  font-weight: 600;
  font-size: 24px;
  line-height: 34px;
  color: #282f38;
  margin-top: 40px;
`

const Content = styled.div`
  font-size: 14px;
  line-height: 22px;
  text-align: center;
  color: #4e5969;
  opacity: 0.8;
  margin: 16px 0 32px 0;
`

const IntroContaienr = styled.div`
  width: 343px;
  background: #ffffff;
  box-shadow: 0px 8px 50px rgba(225, 234, 244, 0.6);
  border-radius: 12px;
  position: relative;
  padding: 40px 48px 56px 20px;
  box-sizing: border-box;
  overflow: hidden;
`

const IconIntro1 = styled(Intro1)`
  position: absolute;
  right: -32px;
  bottom: -50px;
  width: 257px;
  height: 281px;
`
const IconIntro2 = styled(Intro2)`
  position: absolute;
  right: -32px;
  bottom: -50px;
  width: 257px;
  height: 281px;
`

const IntroTitle = styled.div`
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  color: #1d2129;
`

const IntroContent = styled.div`
  width: 275px;
  margin-top: 16px;
  margin-bottom: 32px;
  font-size: 13px;
  line-height: 22px;
  color: #4e5a83;
  opacity: 0.8;
`

const IntroItemContainer = styled.div`
  margin-top: 8px;
  font-size: 14px;
  line-height: 22px;
  color: #00114b;
  opacity: 0.8;
  display: flex;
  align-items: center;
  z-index: 100;
`

const IconYes = styled(Yes)`
  width: 14px;
  height: 14px;
  margin-right: 16px;
`

const IconLine = styled(Line)`
  width: 20px;
  height: 20px;
`

const IntroItem = (props: { text: string }) => {
  return (
    <IntroItemContainer>
      <IconYes></IconYes>
      <div>{props.text}</div>
    </IntroItemContainer>
  )
}

const CollapseTitle = styled.div`
  width: 343px;
  display: flex;
  justify-content: space-between;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: #1d2129;
  margin: 40px 0 12px 0;
`

const StyledCollapse = styled(Collapse)`
  .arco-collapse-item-header {
    width: 343px;
    height: 54px;
    background: #f5f8ff !important;
    border: unset;
  }
  .arco-collapse-item-header-title {
    font-weight: unset !important;
  }
  .arco-collapse-item-content {
    background-color: unset;
    padding: 0;
  }
  .arco-collapse-item {
    border-bottom: unset;
  }
  .arco-collapse-item-header-icon-down {
    transform: rotate(180deg);
  }
  .arco-collapse-item-header-icon {
    width: 12px;
    height: 12px;
    transition: unset;
  }
  .arco-collapse-item-content-box {
    padding: 0;
  }
`

const StyledRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #f4f4f4;
  width: 343px;
  height: 52px;
`
const StyleCol = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  line-height: 20px;
  color: #4e5969;
`

export default Intro
